"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Detail = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _cssInJs = require("@compiled/css-in-js");

var _react = _interopRequireWildcard(require("react"));

var _errorBoundary = require("../errorBoundary");

var _action = require("./action");

var _base = require("./base");

var _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/detail/detail.tsx",
    _this = void 0;

/** Component dispaying a detailed view of the specified game data. */
var Detail = /*#__PURE__*/(0, _react.memo)(function Detail(props) {
  return /*#__PURE__*/_react["default"].createElement(Container, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement(_errorBoundary.ErrorBoundary, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 4
    }
  }, /*#__PURE__*/_react["default"].createElement(Content, (0, _extends2["default"])({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 5
    }
  }))), /*#__PURE__*/_react["default"].createElement(Attribution, {
    href: "https://xivapi.com",
    target: "_blank",
    rel: "noopener noreferrer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 4
    }
  }, "xivapi.com"));
});
exports.Detail = Detail;

function Content(_ref) {
  var sheet = _ref.sheet,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["sheet"]);

  switch (sheet.toLowerCase()) {
    case 'action':
      return /*#__PURE__*/_react["default"].createElement(_action.ActionContent, (0, _extends2["default"])({}, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20,
          columnNumber: 20
        }
      }));

    default:
      return /*#__PURE__*/_react["default"].createElement(_base.BaseContent, (0, _extends2["default"])({
        sheet: sheet
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22,
          columnNumber: 20
        }
      }));
  }
}

var Container = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _ref2$as = _ref2.as,
      C = _ref2$as === void 0 ? "div" : _ref2$as,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 88
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "9u998j",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 92
    }
  }, [".cc-9u998j{box-sizing:border-box}", ".cc-9u998j *{box-sizing:border-box}", ".cc-9u998j{position:relative;border:1px solid #111;border-radius:5px;width:330px;background:#282828;color:white;font:12px/18px Arial,'Helvetica Neue',Helvetica,sans-serif;box-shadow:inset 0 0 3px #444,0 0 10px 2px #111}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-9u998j" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 416
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Container.displayName = "Container";
}

var Attribution = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var _ref3$as = _ref3.as,
      C = _ref3$as === void 0 ? "a" : _ref3$as,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 88
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "f56aii",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 92
    }
  }, [".cc-f56aii{position:absolute;bottom:0;right:0;display:block;font-size:10px;line-height:10px;padding:3px;color:#666;text-align:right;text-decoration:none}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-f56aii" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 274
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Attribution.displayName = "Attribution";
}